module.exports = __webpack_public_path__ + "fonts/ionicons.99ac3308.woff";